import React, { FC } from 'react'
import { Checkbox } from '../../../../legacy-design-system/checkbox'
import { css } from '@emotion/css'
import { useIntl } from 'react-intl'
import { useController, useFormContext } from 'react-hook-form'
import { JiraFormFieldTypes } from './jira-form-field-types'
import { Box, Row } from '../../../../legacy-design-system/form'
import { AutoCreateTicketsRules } from './auto-create-tickets-rules'
import { JiraIntegrationForm } from './jira-form-schema'

export const AutoCreateTicketsFields: FC = () => {
  const { formatMessage } = useIntl()
  const {
    field: { onChange, value }
  } = useController({ name: JiraFormFieldTypes.AUTO_CREATE_TICKETS_ENABLED })

  const { watch } = useFormContext<JiraIntegrationForm>()

  const watchProject = watch(JiraFormFieldTypes.PROJECT)
  const watchIssueType = watch(JiraFormFieldTypes.ISSUE_TYPE)

  return watchProject && watchIssueType ? (
    <div
      className={css`
        display: flex;
        flex-flow: column;
      `}
    >
      <Checkbox
        onChange={onChange}
        label={formatMessage({
          id: 'detail_integrationsSettings_automaticallyCreateTickets'
        })}
        value={value}
      />

      <Row>
        <Box basis={9}>
          <AutoCreateTicketsRules />
        </Box>
      </Row>
    </div>
  ) : null
}
